<template>
    <div :class="['side-nav', { 'mobile': isMobile }]">
      <div class="nav-item" @mouseover="showPhone" @mouseleave="hidePhone" @click="goToPhone">
        <img :src="currentIcon1" alt="联系电话400-0068-930" />
        <!-- <span v-if="showPhoneNumber">{{ phoneNumber }}</span> -->
        <span v-if="showPhoneNumber">{{ phoneNumber }}</span>
      </div>
      <div class="nav-item" @mouseover="showQRCode" @mouseleave="hideQRCode">
        <img :src="currentIcon2" alt="九点半企微客服" />
        <!-- <span v-if="showQRCodeImage">企微客服二维码</span> -->
        <span class="qwkf"  v-if="showQRCodeImage">
            <img :src="qwkf" alt="九点半企微客服">
        </span>
      </div>
      <div class="nav-item" @click="goToContact" @mouseover="showWrite" @mouseleave="hideWrite">
            <img :src="currentIcon3" alt="九点半联系我们" />
      </div>
      <div class="nav-item" @mouseover="showMiniProgram" @mouseleave="hideMiniProgram">
        <img :src="currentIcon4" alt="九点半b端微信小程序" />
        <span class="applet" v-if="showMiniProgramImage">
            <img :src="applet" alt="九点半b端微信小程序">
        </span>
        <!-- <span v-if="showMiniProgramImage">微信小程序二维码</span> -->
      </div>
      <div class="nav-item toTop" @mouseover="showTop" @mouseleave="hideTop" @click="goToTop">
        <img :src="currentIcon5" alt="返回顶部" />
      </div>
    </div>
  </template>
  
  <script>
    import { ref, computed } from 'vue';
    import { useRouter } from 'vue-router';
    import { imagePath } from '@/utils/imagePath';

    // import kf1 from 'https://wcdn.930pm.cn/images/kf1.png';
    // import kf2 from 'https://wcdn.930pm.cn/images/kf2.png';
    // import wx1 from 'https://wcdn.930pm.cn/images/wx1.png';
    // import wx2 from 'https://wcdn.930pm.cn/images/wx2.png';
    // import xcx1 from 'https://wcdn.930pm.cn/images/xcx1.png';
    // import xcx2 from 'https://wcdn.930pm.cn/images/xcx2.png';
    // import write1 from 'https://wcdn.930pm.cn/images/write1.png';
    // import write2 from 'https://wcdn.930pm.cn/images/write2.png';
    // import top1 from 'https://wcdn.930pm.cn/images/top1.png';
    // import top2 from 'https://wcdn.930pm.cn/images/top2.png';
    import qwkf from '@/assets/images/qwkf.jpg';
    import applet from '@/assets/images/applet.jpg';
  
  export default {
    data() {
        return {
            phoneNumber: '400-0068-930',
            showPhoneNumber: false,
            showQRCodeImage: false,
            showMiniProgramImage: false,
          
            currentIcon1: 'https://wcdn.930pm.cn/images/kf1.png',
            currentIcon2: 'https://wcdn.930pm.cn/images/wx1.png',
            currentIcon3: 'https://wcdn.930pm.cn/images/write1.png',
            currentIcon4: 'https://wcdn.930pm.cn/images/xcx1.png',
            currentIcon5: 'https://wcdn.930pm.cn/images/top1.png',
            // kf1: kf1,
            // kf2: kf2,
            // wx1: wx1,
            // wx2: wx2,
            // xcx1: xcx1,
            // xcx2: xcx2,
            // write1: write1,
            // write2: write2,
            // top1: top1,
            // top2: top2,
            qwkf: imagePath(qwkf),
            applet: imagePath(applet),
            router: useRouter(),
        };
    },
    
    computed: {
    isMobile() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    goToPhone() {
        console.log('555',this.isMobile)
      if (this.isMobile) {
        // 在移动端拨打电话
        window.location.href = `tel:${this.phoneNumber}`;
      } 
    },
    goToMiniProgram() {
        console.log('555',this.isMobile)
      if (this.isMobile) {
        // 在移动端拨打电话
        window.location.href = `tel:${this.phoneNumber}`;
      } 
    },
    showPhone() {
      if (!this.isMobile) {
        this.showPhoneNumber = true;
        this.currentIcon1 =  'https://wcdn.930pm.cn/images/kf2.png';
      }
    },
    hidePhone() {
      this.showPhoneNumber = false;
      this.currentIcon1 = 'https://wcdn.930pm.cn/images/kf1.png';
    },
    showQRCode() {
      this.showQRCodeImage = true;
      this.currentIcon2 = 'https://wcdn.930pm.cn/images/wx2.png';
    },
    hideQRCode() {
      this.showQRCodeImage = false;
      this.currentIcon2 = 'https://wcdn.930pm.cn/images/wx1.png'; // 恢复原图标
    },
    showMiniProgram() {
        this.showMiniProgramImage = true;
        this.currentIcon4 = 'https://wcdn.930pm.cn/images/xcx2.png';
    },
    hideMiniProgram() {
      this.showMiniProgramImage = false;
      this.currentIcon4 = 'https://wcdn.930pm.cn/images/xcx1.png'; // 恢复原图标
    },
    showWrite() {
        this.currentIcon3 = 'https://wcdn.930pm.cn/images/write2.png';
    },
    hideWrite() {
      this.currentIcon3 = 'https://wcdn.930pm.cn/images/write1.png'; // 恢复原图标
    },
    showTop() {
      this.currentIcon5 = 'https://wcdn.930pm.cn/images/top2.png';
    },
    hideTop() {
        this.currentIcon5 = 'https://wcdn.930pm.cn/images/top1.png';
    },
    goToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    goToContact() {
        this.router.push('/toRegister');
    },
  },
  };
  </script>
  
  <style scoped>
  .side-nav {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    background-color: #2a2b26;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    z-index: 9999;
  }
  
  .side-nav.mobile {
    bottom: 0;
    top: auto;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    transform: none;
  }
  
  .nav-item {
    position: relative;
    padding: 16px 14px;
    cursor: pointer;
    border-bottom: 1px solid #000;
  }
  .nav-item:last-child {
    border-bottom: none;
  }
  .nav-item img {
    width: 40px; /* 图标大小 */
    height: 40px; /* 图标大小 */
  }
  
  .nav-item span {
    position: absolute;
    left: -140px; /* 从左边弹出，调整这个值以改变气泡框的位置 */
    top: 50%;
    font-size: 16px;
    transform: translateY(-50%); /* 垂直居中 */
    background-color: white; /* 气泡框背景色 */
    color: black; /* 字体颜色 */
    padding: 10px 15px; /* 内边距 */
    border-radius: 5px; /* 圆角 */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); /* 阴影效果 */
    white-space: nowrap; /* 防止换行 */
    transition: opacity 0.3s ease; /* 添加过渡效果 */
    opacity: 1; /* 初始透明度为 0 */
    display: block;
}
/* 添加小三角形 */
.nav-item span::after {
  content: '';
  position: absolute;
  left: 100%; /* 三角形位置在气泡框的右边 */
  top: 50%;
  margin-top: -10px; /* 垂直居中 */
  border-width: 10px; /* 三角形的大小 */
  border-style: solid;
  border-color: transparent transparent transparent white; /* 三角形颜色 */
}
.nav-item .qwkf ,.nav-item .applet {
    left: -170px;
}
.qwkf img,.applet img{
    width: 124px;
    height: 171px;
}
  @media (max-width: 768px) {
    .toTop {
      display: none;
    }
    .nav-item{
      padding: 10px;
    }
    .nav-item .qwkf ,.nav-item .applet {
    left:-50%;
    top: -110px;
}
.nav-item span::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 206px;
  bottom: -20px; /* 三角形位置在气泡框的右边 */
  margin-top: -10px; /* 垂直居中 */
  border-width: 10px; /* 三角形的大小 */
  border-style: solid;
  border-color: #fff transparent transparent transparent; /* 三角形颜色 */
  transform:translateX(-50%);
}
.nav-item .applet {
 left: -100%;
}
.side-nav {
    border-top-right-radius: 8px;
    border-bottom-left-radius: 0;
}
}
  </style>